import { supabase } from './supabase';

// El correo acompaña una activación ya confirmada; su fallo nunca debe hacer
// creer a la persona que la prueba o su cuenta fallaron. El servidor conserva
// las reservas de envío y registra errores para conciliarlos.
export async function solicitarBienvenida(tipo = 'cuenta') {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) return false;
    const respuesta = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/send-welcome`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
      body: JSON.stringify({ tipo }),
    });
    return respuesta.ok;
  } catch { return false; }
}
